module.exports = __webpack_public_path__ + "img/cert1.5499fe0d.png";